<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { useI18n } from "vue-i18n"

// ================================
// INTERNATIONALIZATION
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            title: "Reprendre l'inscription ?",
            message:
                "Vous avez un formulaire d'inscription en cours. Souhaitez-vous reprendre le parcours où vous l'avez arrêté ?",
            resume: "Reprendre",
            restart: "Recommencer",
        },
    },
})

// ================================
// PROPS & EMITS
// ================================
const [visible] = defineModel<boolean>("visible", {
    required: true,
    default: false,
})

const emit = defineEmits<{
    (e: "resume"): void
    (e: "restart"): void
}>()

// ================================
// INTERACTIONS
// ================================

/** L'utilisateur choisit de reprendre le parcours (données déjà dans le store). */
function onResume(): void {
    visible.value = false
    emit("resume")
}

/** L'utilisateur choisit de recommencer (effacer le brouillon et repartir à l'étape intro). */
function onRestart(): void {
    visible.value = false
    emit("restart")
}
</script>

<template>
    <BaseDialog
        v-model:visible="visible"
        modal
        :closable="false"
        dismissable-mask
        class="subscription-form-resume-dialog max-w-[28rem] w-full"
    >
        <template #header>
            <h2 class="text-lg text-primary font-semibold">
                {{ t("title") }}
            </h2>
        </template>
        <p class="text-primary py-4">
            {{ t("message") }}
        </p>
        <div class="flex flex-wrap gap-2 justify-end pt-2">
            <BaseButton outlined :label="t('restart')" @click="onRestart" />
            <BaseButton :label="t('resume')" @click="onResume" />
        </div>
    </BaseDialog>
</template>
